<template>
    <div ref="carousel" class="carousel slide">
        <div class="carousel-inner">
            <slot/>
        </div>
        <a class="carousel-control-prev" role="button" @click="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" role="button" @click="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
        </a>
    </div>
</template>

<script>
import jQuery from "jquery";
export default {
    name: "Carousel",

    methods: {
        prev(){
            jQuery( this.$refs.carousel ).carousel('prev');
        },
        next(){
            jQuery( this.$refs.carousel ).carousel('next');
        }
    },

    mounted(){
        jQuery( this.$refs.carousel ).carousel({
            interval: 3000,
            wrap: true,
        });
    },

    beforeUnmount() {
        jQuery( this.$refs.carousel ).carousel('dispose');
    }
}
</script>

<style lang="scss" scoped>
.carousel-control-next-icon, .carousel-control-prev-icon{
    background-color: $feel;
    padding: 1rem;
    border-radius: 50%;
    background-size: 50%;
}
</style>
